import axios from 'axios';
import generalCatchError from './generalCatchError';
import { getItem, STORAGE_KEYS } from '../storage';
import config from '../../config';

class HttpService {
  constructor(baseUrl = '', generalCatch = generalCatchError) {
    this.axiosInstance = axios.create({
      baseURL: baseUrl,
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        AuthorizationFromPortal: true,
      },
    });
    this.generalCatch = generalCatch;
  }

  async get(url, options = {}) {
    try {
      const user = getItem(STORAGE_KEYS.USER);
      const apiKey = user?.tokenId;
      const userEmail = user?.profileObj?.email;

      const response = await this.axiosInstance.get(url, {
        ...options,
        headers: {
          Authorization: `Bearer ${apiKey}`,
          ...options.headers,
        },
        params: {
          userEmail,
          ...options.params,
        },
      });
      return response.data;
    } catch (error) {
      this.generalCatch(error);
      throw error;
    }
  }

  async post(url, data, options = {}) {
    try {
      const user = getItem(STORAGE_KEYS.USER);
      const apiKey = user?.tokenId;
      const userEmail = user?.profileObj?.email;

      const response = await this.axiosInstance.post(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...options,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...options.headers,
          },
          params: {
            userEmail,
            ...options.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      this.generalCatch(error);
      throw error;
    }
  }

  async put(url, data, options = {}) {
    try {
      const user = getItem(STORAGE_KEYS.USER);
      const apiKey = user?.tokenId;
      const userEmail = user?.profileObj?.email;

      const response = await this.axiosInstance.put(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...options,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...options.headers,
          },
          params: {
            userEmail,
            ...options.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      this.generalCatch(error);
      throw error;
    }
  }

  async patch(url, data, options = {}) {
    try {
      const user = getItem(STORAGE_KEYS.USER);
      const apiKey = user?.tokenId;
      const userEmail = user?.profileObj?.email;

      const response = await this.axiosInstance.patch(
        url,
        {
          userEmail,
          ...data,
        },
        {
          ...options,
          headers: {
            Authorization: `Bearer ${apiKey}`,
            ...options.headers,
          },
          params: {
            userEmail,
            ...options.params,
          },
        },
      );
      return response.data;
    } catch (error) {
      this.generalCatch(error);
      throw error;
    }
  }

  async delete(url, options = {}) {
    try {
      const user = getItem(STORAGE_KEYS.USER);
      const apiKey = user?.tokenId;
      const userEmail = user?.profileObj?.email;

      await this.axiosInstance.delete(url, {
        ...options,
        headers: {
          Authorization: `Bearer ${apiKey}`,
          ...options.headers,
        },
        params: {
          userEmail,
          ...options.params,
        },
      });
    } catch (error) {
      this.generalCatch(error);
      throw error;
    }
  }
}

export const httpServiceInstanceNode = new HttpService(config.REACT_APP_NODE_API);
export default HttpService;
